import { Cliente } from "../model/Cliente";
import { ClienteEndereco } from "../model/clienteEndereco";

export class ClienteDTO {
  public cliente!: Cliente;
  public enderecos!: Array<ClienteEndereco>;
  public propostaEsteira!: boolean;
  public idMotivo!: string | null;
}